import { z } from "zod";

/** Same as storage `file` field on lessons (full Firebase Storage path). */
export const RequestDownloadBodySchema = z.object({
  filePath: z.string().min(1),
});

export type RequestDownloadBody = z.infer<typeof RequestDownloadBodySchema>;

export interface RequestDownloadSuccess {
  downloadUrl: string;
  /** Base64-encoded 32-byte AES-256 key for client-side encryption */
  aesKey: string;
  fileSize: number;
  /** Seconds until signed URL expires */
  expiresIn: number;
}
